import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import moment from "moment";

const ActivityLogsModal = ({ onClose, logs = [] }) => {
    return (
        <ModalContainer>
            <Container>
                <Header>
                    <Title>Activity Logs</Title>
                    <button onClick={onClose}>
                        <MdClose color="white" size={24} />
                    </button>
                </Header>

                <Content>
                    <ScrollableContent>
                        {logs.length === 0 ? (
                            <EmptyState>No activity found</EmptyState>
                        ) : (
                            <TimelineWrapper>
                                {logs.map((log, index) => (
                                    <TimelineRow key={index}>
                                        {/* Left Timeline Indicator */}
                                        <TimelineLeft>
                                            <TimelineDot />
                                            {index !== logs.length - 1 && <TimelineLine />}
                                        </TimelineLeft>

                                        {/* Content */}
                                        <TimelineContent>
                                            <DateText>
                                                {moment(log.createdAt).format("DD MMM YYYY, hh:mm A")}
                                            </DateText>
                                            <ActivityText>{log.activityTitle}</ActivityText>
                                            <DescriptionText>{log.description || "--"}</DescriptionText>
                                        </TimelineContent>
                                    </TimelineRow>
                                ))}
                            </TimelineWrapper>
                        )}
                    </ScrollableContent>
                </Content>
            </Container>
        </ModalContainer>
    );
};

// -------------------- Styled Components --------------------

const ModalContainer = tw.div`
    fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50
`;

const Container = tw.div`
    bg-white w-full h-full min-h-[100vh] flex flex-col
`;

const Header = tw.div`
    flex items-center justify-between bg-[#26A69A] py-4 px-4
`;

const Title = tw.h1`
    text-lg md:text-xl font-medium text-white
`;

const Content = tw.div`
    p-4 flex flex-col gap-4
`;

const ScrollableContent = tw.div`
    overflow-y-auto h-[calc(100vh-120px)] pr-3
`;

const EmptyState = tw.div`
    text-center text-gray-400 mt-52
`;

const TimelineWrapper = tw.div`
    relative space-y-6
`;

const TimelineRow = tw.div`
    flex gap-4 relative
`;

const TimelineLeft = tw.div`
    flex flex-col items-center relative
    min-w-[20px]
`;

const TimelineDot = tw.div`
    w-3 h-3 bg-blue-500 rounded-full
`;

const TimelineLine = tw.div`
    w-0.5 bg-gray-300 flex-1
`;

const TimelineContent = tw.div`
    flex flex-col gap-0.5 pb-4 border-b border-gray-100 w-full
`;

const DateText = tw.p`
    text-xs text-gray-400
`;

const ActivityText = tw.p`
    text-sm font-semibold text-gray-700
`;

const DescriptionText = tw.p`
    text-sm text-gray-500
`;

export default ActivityLogsModal;
